import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HotelService } from 'src/app/services/hotel.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'travel-ui-static-page',
  templateUrl: './static-page.component.html',
  styleUrls: ['./static-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StaticPageComponent implements OnInit {
  
  data: any;
  showLoader = false
  html: SafeHtml | undefined;
  constructor( private sanitizer: DomSanitizer,private route: ActivatedRoute, private hotelService: HotelService,) {
 
   }

  ngOnInit(): void {
    const pageId = this.route.snapshot.params['id'];
    this.getContent(pageId)
  }

  getContent(pageId: string){
    this.hotelService.getstaticPageContent(pageId).subscribe((res: any)=>{
      this.data= res['response'];
      this.showLoader = true
      this.html=this.sanitizer.bypassSecurityTrustHtml(this.data?.content)
    })
    }
  }  

